// @flow
import React from 'react'
import { Box, boxProps } from 'frack-components'
import config from '../../../config.js'

type Props = boxProps

const Row = (props: Props) => <Box {...props} />

Row.defaultProps = {
  negativeMargin: config.gutter,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  flexWrap: 'wrap',
}

export default Row
